import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

export const useRefreshTokenMutation = () => {
  return useMutation(() =>
    axios.post('/api/account/acceptRefreshToken/')
  )
}
